/**
 * Defines a cursor-based collection of notifications.
 */
import CursorPagedCollection from 'collections/utils/CursorPagedCollection';

import Notification from 'models/notification/Notification';

import { COUNTED_NOTIFICATION_TYPES } from 'utils/notification/notificationConstants';

const DEFAULT_PAGE_LIMIT = 10;

const Notifications = CursorPagedCollection.extend({
    model: Notification,

    backend: 'gcapi',

    baseUrl: '/notification-service/notification/notification/cursor',

    initialize: function(models, args) {
        let opts = {
            verb: 'GET',
            shouldSort: false,
            cursor: null, // initialize the cursor to null to fetch from the very beginning
            limit: args && args.limit ? args.limit : DEFAULT_PAGE_LIMIT
        };

        this.initializeCursorPagedCollection(opts);
    },

    parse: function(resp) {
        return resp.notificationList.filter((notification) =>
            COUNTED_NOTIFICATION_TYPES.hasOwnProperty(notification.type)
        );
    }
});

export default Notifications;
